'use client';
import { createContext } from 'react';

const PlaylistContext = createContext();

export default PlaylistContext;
